export default __webpack_public_path__ + "static/media/FullSceneMidNightBaked.4c4b053d.glb";